/**
 * 首頁公告分類頁籤切換
 *
 * 原本這段程式碼被附加在 static/js/jquery-latest.min.js 的檔尾（該檔實為
 * jQuery 1.11.1，含 CVE-2020-11022）。為了移除該版 jQuery，將這段自訂邏輯
 * 抽出獨立成模組，內容未做任何行為變更。
 *
 * 其中的 $ 由 webpack ProvidePlugin 注入（見 build/webpack.base.conf.js），
 * 使用的是 package.json 指定的 npm jQuery。
 */
export default {
  init: function() {
    var _showTab = 0;
    var $defaultLi = $('ul.tabs li').eq(_showTab);
    $($defaultLi.find('a').attr('href')).siblings().hide();
    $('ul.tabs li').click(function() {
      var $this = $(this),
        _clickTab = $this.find('a').attr('href');
      $('ul.tabs li').removeClass('active')
      $this.addClass('active').siblings('.active');
      $(_clickTab).stop(false, true).fadeIn().siblings().hide();

      return false;
    }).find('a').focus(function() {
      this.blur();
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/library/tabs.js